import React from 'react';
import styles from './CompletionBadge.module.scss';

export type CompletionBadgeProps = {
    completedFields: number;
    totalFields: number;
    className?: string;
};

export const CompletionBadge = ({ completedFields, totalFields, className }: CompletionBadgeProps) => {
    if (totalFields === 0) {
        return null;
    }

    return (
        <span className={`${styles.completionBadge} ${className || ''}`}>
            {completedFields}/{totalFields}
        </span>
    );
};

export default CompletionBadge;
